import React from 'react';
import { faqs } from '../../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 px-6 bg-[#0a0a0a]">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4 block">
            FAQ
          </span>
          <h2 className="heading-2 text-white mb-4">Questions? Answers.</h2>
          <p className="body-medium text-[#737373] max-w-2xl mx-auto">
            Everything you need to know about AutoPostr and how it works.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="border border-white/10 rounded-2xl px-6 bg-[#141414] data-[state=open]:border-white/20 transition-all duration-200"
            >
              <AccordionTrigger className="text-left font-semibold text-white hover:no-underline py-5 [&[data-state=open]>svg]:text-white">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#737373] pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
